export enum SelectionBoxesCount {
    PointBox = 3,
    TwoBox = 2,
    ThreeBox = 3
}